import { useSuspenseQuery } from '@apollo/client/react';
import dayjs from 'dayjs';

import { GeneratedAgreementContent, GeneratedAgreementSidebar } from 'src/components/Escrow/Agreement';
import { AgreementFormEnum } from 'src/graphql/schema';
import { SoftwareEscrowAgreementTermsDocument } from 'src/graphql/actions/softwareEscrow/softwareEscrowAgreementTerms.query';
import { withSuspense } from 'src/hoc';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { getTimeZoneAbbreviation } from 'src/utils/getTimeZoneAbbreviation';

const AgreementPreview = () => {
  const {
    softwareEscrow: { id: softwareEscrowId, depositor, beneficiary, agreement },
  } = useSoftwareEscrow();
  const { data: dataAgreement } = useSuspenseQuery(SoftwareEscrowAgreementTermsDocument, {
    variables: { softwareEscrowId },
    skip: !softwareEscrowId,
  });

  const tz = getTimeZoneAbbreviation(Intl.DateTimeFormat().resolvedOptions().timeZone);
  const timestamp = dayjs().format(`DD MMM YYYY HH:mm [${tz}]`);
  const fileName = (
    [depositor?.companyName, beneficiary?.companyName].filter(Boolean).join(' - ') + ` agreement - ${timestamp}`
  ).trim();

  return (
    <div className="container mx-auto h-full @container">
      <div className="flex flex-col md:flex-row gap-4 h-full @max-3xl:flex-col">
        <div className="grow-1 min-h-[350px] h-full overflow-hidden">
          <GeneratedAgreementContent
            fileName={fileName}
            terms={dataAgreement?.softwareEscrowTerms.agreement?.terms ?? ''}
            termsSignedDownloadPdfUrl={dataAgreement?.softwareEscrowTerms.agreement?.termsSignedDownloadPdfUrl ?? ''}
          />
        </div>

        <div className="shrink-0 w-full md:w-[250px] pb-6 @max-3xl:w-full">
          <GeneratedAgreementSidebar
            approvedBy={{
              beneficiary: Boolean(agreement.approvedByBeneficiary),
              codekeeper: Boolean(agreement.approvedByCodekeeper),
              depositor: Boolean(agreement.approvedByDepositor),
            }}
            download={{
              docxUrl: dataAgreement?.softwareEscrowTerms.agreement?.termsDownloadDocxUrl ?? '',
              pdfUrl: dataAgreement?.softwareEscrowTerms.agreement?.termsDownloadPdfUrl ?? '',
              signedPdfUrl: dataAgreement?.softwareEscrowTerms.agreement?.termsSignedDownloadPdfUrl ?? '',
            }}
            updatedAt={agreement.updatedAt}
            fileName={fileName}
            isTripartite={agreement.agreementForm === AgreementFormEnum.Tripartite}
            canDownload={agreement.policy.download}
          />
        </div>
      </div>
    </div>
  );
};

export default withSuspense(AgreementPreview);
